interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-411">
      <div className="ml" data-id="element-412">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-413">{value}</div>
      <div className="ms" data-id="element-414">{sub}</div>
    </div>;
}